import { PublicClientApplication } from '@azure/msal-browser'
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google'
import apiFetch from '../common/apiFetch'

export const microsoftLoginSignupHandler = async (clientId: string) => {
	const config = {
		auth: {
			clientId: clientId,
		},
	}
	const msalInstance = new PublicClientApplication(config)
	const loginRequest = {
		scopes: ['user.read'],
	}
	const respFromMicrosoftApi = await msalInstance.loginPopup(loginRequest)
	const token = respFromMicrosoftApi.idToken
	const resp = await apiFetch(`/external/oauth/microsoftSignin`, {
		credentials: 'same-origin',
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ token }),
	})
	const result = await resp.json()
	return { result, respFromMicrosoftApi }
}

export const googleLoginSignupHandler = async (response: any) => {
	const googleCredential = response?.credential
	const resp = await apiFetch(`/external/oauth/googleSignin`, {
		credentials: 'same-origin',
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ googleCredential }),
	})
	const result = await resp.json()
	return result
}
